// extracted by mini-css-extract-plugin
export default {"modalOverlay":"gA-z","modalContent":"hA-z","header":"iA-z","close":"jA-z"};